import type { EventCategory } from './types';

export const TAG_COLORS: Record<EventCategory, { bg: string; text: string; border: string }> = {
  ceremony: {
    bg: 'rgba(167, 139, 250, 0.15)',
    text: '#A78BFA',
    border: 'rgba(167, 139, 250, 0.3)',
  },
  reception: {
    bg: 'rgba(244, 114, 182, 0.15)',
    text: '#F472B6',
    border: 'rgba(244, 114, 182, 0.3)',
  },
  photo: {
    bg: 'rgba(56, 189, 248, 0.15)',
    text: '#38BDF8',
    border: 'rgba(56, 189, 248, 0.3)',
  },
  video: {
    bg: 'rgba(251, 146, 60, 0.15)',
    text: '#FB923C',
    border: 'rgba(251, 146, 60, 0.3)',
  },
  music: {
    bg: 'rgba(52, 211, 153, 0.15)',
    text: '#34D399',
    border: 'rgba(52, 211, 153, 0.3)',
  },
  catering: {
    bg: 'rgba(251, 191, 36, 0.15)',
    text: '#FBBF24',
    border: 'rgba(251, 191, 36, 0.3)',
  },
  floral: {
    bg: 'rgba(249, 168, 212, 0.15)',
    text: '#F9A8D4',
    border: 'rgba(249, 168, 212, 0.3)',
  },
  all: {
    bg: 'rgba(148, 163, 184, 0.15)',
    text: '#94A3B8',
    border: 'rgba(148, 163, 184, 0.3)',
  },
};

export const CATEGORY_LABELS: Record<EventCategory, string> = {
  ceremony: 'Ceremony',
  reception: 'Reception',
  photo: 'Photo',
  video: 'Video',
  music: 'Music',
  catering: 'Catering',
  floral: 'Floral',
  all: 'All',
};

export const ALL_CATEGORIES: EventCategory[] = [
  'ceremony',
  'reception',
  'photo',
  'video',
  'music',
  'catering',
  'floral',
  'all',
];

export const TIME_BLOCKS = {
  MORNING: { label: 'Morning', end: 12 },
  AFTERNOON: { label: 'Afternoon', start: 12, end: 17 },
  EVENING: { label: 'Evening', start: 17 },
} as const;

export const LEAD_TIMES = [30, 10, 5, 0] as const;

export const DEFAULT_PREFERENCES = {
  categoryFilter: ['all'] as const,
  notifyLeadTimes: [30, 10, 5, 0],
  quietMode: false,
  onboardingComplete: false,
};

export const API_BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:8787';
